import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button, Stack, Tabs, Tab,
  CircularProgress, Alert, Table, TableHead, TableBody, TableRow, TableCell,
  Chip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";

const ProSearch = () => {
  const [mode, setMode] = React.useState(0); // 0=name 1=geo 2=job-spec
  const [q, setQ] = React.useState("");
  const [city, setCity] = React.useState("");
  const [radius, setRadius] = React.useState(20);
  const [job, setJob] = React.useState("");
  const [speciality, setSpeciality] = React.useState("");
  const [results, setResults] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();

  const search = async () => {
    setLoading(true);
    let url;
    if (mode === 0) url = `${API_BASE_URL}/pro/search?query=${encodeURIComponent(q)}`;
    else if (mode === 1) url = `${API_BASE_URL}/pro/search/geo?city=${encodeURIComponent(city)}&radius=${radius}`;
    else url = `${API_BASE_URL}/pro/search-by-job-speciality?job=${encodeURIComponent(job)}&specialityId=${encodeURIComponent(speciality)}`;
    try {
      const { json } = await httpClient(url);
      setResults(Array.isArray(json) ? json : json?.data || []);
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <SearchIcon /> Recherche pro
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Outils de recherche backend des professionnels (nom, géo, métier+spé).
      </Alert>
      <Tabs value={mode} onChange={(_, v) => setMode(v)} sx={{ mb: 2 }}>
        <Tab label="Par nom" />
        <Tab label="Par ville/rayon" />
        <Tab label="Par métier + spécialité" />
      </Tabs>
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Stack spacing={2}>
            {mode === 0 && (
              <TextField size="small" label="Nom / spécialité"
                value={q} onChange={(e) => setQ(e.target.value)} />
            )}
            {mode === 1 && (
              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField size="small" label="Ville" value={city}
                  onChange={(e) => setCity(e.target.value)} />
                <TextField size="small" type="number" label="Rayon (km)"
                  value={radius} onChange={(e) => setRadius(Number(e.target.value))} />
              </Box>
            )}
            {mode === 2 && (
              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField size="small" label="Métier" value={job}
                  onChange={(e) => setJob(e.target.value)} />
                <TextField size="small" label="Spécialité" value={speciality}
                  onChange={(e) => setSpeciality(e.target.value)} />
              </Box>
            )}
            <Box>
              <Button variant="contained" onClick={search} disabled={loading}>
                {loading ? <CircularProgress size={18} /> : "Lancer la recherche"}
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Résultats <Chip label={results.length} size="small" />
          </Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Nom</TableCell>
                <TableCell>Spécialité</TableCell>
                <TableCell>Ville</TableCell>
                <TableCell>Rating</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results.length === 0 ? (
                <TableRow><TableCell colSpan={5} align="center">Aucun résultat</TableCell></TableRow>
              ) : results.map((p, i) => (
                <TableRow key={p.id || i}>
                  <TableCell>{p.id}</TableCell>
                  <TableCell>{[p.firstName, p.lastName].filter(Boolean).join(" ") || p.name}</TableCell>
                  <TableCell>{p.speciality}</TableCell>
                  <TableCell>{p.city || p.address?.city}</TableCell>
                  <TableCell>{p.rating}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: ProSearch };
